module.exports = __webpack_public_path__ + "static/media/cards.c74ee5eb.gif";